import { Component, OnInit, OnDestroy } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/services/util.service";
import { ResponseAPI, UserType, User } from "src/models/user.model";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { AuthService } from "src/app/services/auth.service";
import { TipoCorrida } from "src/models/corrida.model";
import { NavigationExtras, Router } from "@angular/router";
import { StatusBar } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Capacitor } from "@capacitor/core";
import { Events } from "src/app/services/events-service.service";
import { OneSignalService } from "../../services/oneSignal.service";
import { register } from "swiper/element/bundle";
import { IonicSlides } from "@ionic/angular";

register();
@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.page.html",
    styleUrls: ["./dashboard.page.scss"],
    standalone: false
})
export class DashboardPage implements OnDestroy {
  sub: Subscription;
  dashboard = {} as any;
  claim: UserType;
  mapVisible = true;
  TipoCorrida = TipoCorrida;
  user: User;
  earningsTotais = {} as any;
  referCount: any;
  modalLink = false;
  linkShare = "placeholder";

  public swiperModules = [IonicSlides];

  constructor(
    private crud: CrudService,
    private loadCtrl: LoadingController,
    private route: Router,
    private platform: Platform,
    private auth: AuthService,
    private events: Events,
    private util: UtilService,
    private oneSignalService: OneSignalService
  ) {}
  async ionViewWillEnter() {
    this.mapVisible = true;
    if (Capacitor.isNativePlatform()) {
      StatusBar.hide().catch(() => {});
      SplashScreen.hide().catch(() => {});
    }
    this.claim = await this.auth.getClaim();
    this.user = this.auth.user;
    await this.showLoading();
    this.events.publish("update:establishments");
    await this.loadDashboard();
    await this.loadEarnings();
    await this.loadSpread();
    await this.loadCtrl.dismiss();
    this.oneSignalService.requestPermissionAndEnableOneSignal();
  }

  ionViewWillLeave() {
    this.mapVisible = false;
    this.events.publish("clear:location");
  }

  async loadDashboard() {
    this.sub = this.crud.getData("dashboard").subscribe(
      async (response: ResponseAPI) => {
        if (response.success) {
          this.dashboard = response.data;
        }
      },
      async (error) => {
        await this.loadCtrl.dismiss();
      }
    );
  }

  async loadEarnings() {
    this.sub = this.crud.getData("earnings/caller").subscribe(
      async (response) => {
        this.earningsTotais = response;
      },
      async (error) => {
        await this.loadCtrl.dismiss();
      }
    );
  }

  async loadSpread() {
    this.sub = this.crud.getData("link/refer-count").subscribe(
      async (response: ResponseAPI) => {
        if (response.success) {
          this.referCount = response.data;
        }
      },
      async (error) => {
        await this.loadCtrl.dismiss();
      }
    );
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadCtrl.create(loadingProps);
    return await loading.present();
  }

  async goToPage(controller: String, path: String) {
    if (path.includes("guest")) {
      this.events.publish("openGuestLink");
    } else {
      await this.route.navigate([controller, path]);
    }
  }

  openModal() {
    this.modalLink = true;
  }

  async generateQrCode() {
    await this.showLoading();
    this.crud
      .postData("Link/qr-code", null, { vendedorId: this.user.id })
      .subscribe(
        async (response: any) => {
          await this.loadCtrl.dismiss();
          this.linkShare = response.data.linkUrl;
          this.openModal();
        },
        async (error) => {
          await this.loadCtrl.dismiss();
          await this.util.showToast("An error occurred to generate the link");
        }
      );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
